export default function Django_Views() {
  return <div>Django_Views Component</div>;
}
